import { jsx as _jsx } from "react/jsx-runtime";
import throttle from 'lodash.throttle';
import { useState, useEffect } from 'react';
import { shouldShowSidebar, widthToSkapaSize } from '../utils/viewportSize';
import { buildContext } from './buildContext';
export const [useViewportContext, ViewportContextProvider] = buildContext();
export const ViewportProvider = ({ children }) => {
    const [viewPortSettings, setViewPortSettings] = useState({
        isSidebarMode: shouldShowSidebar(window.innerWidth),
        isCompact: window.innerWidth < 600,
        currentSkapaSize: widthToSkapaSize(window.innerWidth)
    });
    useEffect(() => {
        const handleResize = throttle(() => {
            const innerWidth = window.innerWidth;
            setViewPortSettings({
                isSidebarMode: shouldShowSidebar(innerWidth),
                isCompact: widthToSkapaSize(innerWidth) === 'S',
                currentSkapaSize: widthToSkapaSize(innerWidth)
            });
        }, 250);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return _jsx(ViewportContextProvider, { value: viewPortSettings, children: children });
};
//# sourceMappingURL=viewportState.js.map